import { createReducer } from 'redux-act'

import { integrationsToStore } from 'Integrations/Integrations/actions'

const initialState = []

export default createReducer({
  [integrationsToStore]: (state, payload) => payload
}, initialState)
